import { createSlice } from "@reduxjs/toolkit";
import {
  getExpenseCodeListThunk,
  getProjectCodeListThunk,
  getCurrencyListThunk,
  getDepartmentListThunk,
} from "../thunks/masterDataThunk";

const initialState = {
  expenseCodes: [],
  projectCodes: [],
  currencies: [],       
  currencyRates: {},
  departments: [],
  loading: false,
  error: null,
};

const masterDataSlice = createSlice({
  name: "masterData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* -----------------------------
       * Expense Codes
       * ----------------------------- */
      .addCase(getExpenseCodeListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExpenseCodeListThunk.fulfilled, (state, action) => {
        state.expenseCodes = action.payload || [];
        state.loading = false;
      })
      .addCase(getExpenseCodeListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* -----------------------------
       * Project Codes
       * ----------------------------- */
      .addCase(getProjectCodeListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProjectCodeListThunk.fulfilled, (state, action) => {
        state.projectCodes = action.payload || [];
        state.loading = false;
      })
      .addCase(getProjectCodeListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      /* -----------------------------
       * Currencies
       * ----------------------------- */
      .addCase(getCurrencyListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrencyListThunk.fulfilled, (state, action) => {
        state.currencies = action.payload.currencyDropdown || [];
         state.currencyRates = action.payload.currencyRates || {};
        state.loading = false;
      })
      .addCase(getCurrencyListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

       /* -----------------------------
       * Departments
       * ----------------------------- */
      .addCase(getDepartmentListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDepartmentListThunk.fulfilled, (state, action) => {
        state.departments = action.payload || [];
        state.loading = false;
      })
      .addCase(getDepartmentListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default masterDataSlice  .reducer;
